import React, { Fragment } from 'react';
import styled from 'styled-components';
import axios from "axios";
import { TimelineMax, Power1 } from "gsap";
import CardIcon from "../components/shared/CardIcon";
import TeamItem from "../components/Studio/TeamItem";
import Footer from "../components/shared/Footer";

const renderHTML = rawHTML => React.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });

class Studio extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      page: {},
    }
    this.timeline = new TimelineMax({ paused: true });
  }

  componentDidMount() {
    axios
      .get(`https://www.paralele.me/api/studio/index.php?lang=${window.languageInt}`)
      .then(res => res.data)
      .then(data => {
        this.setState({ page: data })
      })

    this.timeline
      .from(this.mainHeading, {
        autoAlpha: 0,
        y: 20,
        ease: Power1.ease,
        delay: .3
      })
      .from(this.description, {
        autoAlpha: 0,
        y: 20,
        ease: Power1.ease,
      })
      .from(this.team, {
        autoAlpha: 0,
        y: 20,
        delay: .2,
        ease: Power1.ease,
      })
    this.timeline.play();
  }

  handleTeamClick = itemId => {
    let teamItems = [...this.state.page.team];
    let teamItem = {
      ...teamItems[itemId],
      opened: !teamItems[itemId].opened
    };
    // Reset all opened
    teamItems.map(item => item.opened = false);
    teamItems[itemId] = teamItem;

    this.setState(prevState => {
      return {
        page: {
          ...prevState.page,
          team: [
            ...teamItems
          ]
        }
      }
    })

  }

  render() {
    const { slogan, text, services, team } = this.state.page;
    return (
      <>
        <div className="container">
          <MainHeading ref={heading => (this.mainHeading = heading)}>
            {slogan}
          </MainHeading>
          <Description ref={description => (this.description = description)}>
            {renderHTML(text)}
          </Description>

          {services &&
            <CardIconWrapper>
              {services.map((item, i) => (
                <React.Fragment key={i}>
                  <H2>{item.name}</H2>
                  <Description>{item.text}</Description>
                </React.Fragment>
                // <CardIcon
                //   key={i}
                //   itemId={i}
                //   delay={0.1}
                //   icon={item.icon}
                //   heading={item.name}
                //   text={item.text}
                // />
              ))}
            </CardIconWrapper>
          }

          <TeamListingWrapper ref={team => (this.team = team)}>
            {team &&
              team.map((item, i) => {
                const { name, title, text, image, opened } = item;
                return (
                  <TeamItem
                    image={image}
                    name={name}
                    title={title}
                    text={text}
                    boxOpened={opened}
                    handleTeamClick={this.handleTeamClick}
                    itemId={i}
                    key={i}
                  ></TeamItem>
                )
              })
            }
          </TeamListingWrapper>
        </div>
        <Footer />
      </>
    )
  }
}
const boxOffset = 90;
const TeamListingWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  z-index: 55;
  position: relative;

  >div:nth-child(3n) {
    section {
      @media(min-width: 992px) {
        position: absolute;
        padding: ${boxOffset}px ${320 + boxOffset}px 30px 50px;
        width: calc(100% + 750px);
        height: calc(100% + ${boxOffset * 2}px);
        right: -${boxOffset}px;
        left: initial;
        top: -${boxOffset}px;
        min-height: 410px;
      }
    }
  }
`

const MainHeading = styled.h1`
  font-weight: 100;
  font-size: 24px;
  line-height: 1.5;
  margin-bottom: 40px;

  @media(min-width: 992px) {
    font-size: 40px;
  }
`

const H2 = styled.h2`
  font-weight: 100;
  font-size: 26px;
  line-height: 1.5;
  margin: 30px 0 15px 0;
`


const Description = styled.p`
  font-size: 19px;
`

const CardIconWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 60px;
  margin-bottom: 60px;
`

export default Studio;